module.exports = __webpack_public_path__ + "static/media/classicWhite.3ebdc42c.PNG";